export default __webpack_public_path__ + "static/media/email_icon.30ef2c92.svg";